import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPersonPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1440 1440",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		fill: "#d9dbdd",
		d: "M923.18 1002.31c175.84-77.95 298.56-253.9 298.56-458.64 0-277-224.56-501.57-501.57-501.57S218.6 266.67 218.6 543.68c0 204.72 122.73 380.68 298.56 458.64-228.4 61.43-415.32 224-509.97 436.7h1425.97c-94.66-212.71-281.58-375.27-509.98-436.7z"
	})
});
export default SvgPersonPlaceholder;
